import PlatformFeeDetails from "../../services/api/PlatformFeeDetails";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
    console.log("error in support fee details actions:", err);
}

export const setPlatformFeeDetails = (payload) => {
    return {
        type: ActionTypes.SET_PLATFORM_FEE_DETAILS,
        payload,
    };
};

export const resetState = (payload) => {
    return {
        type: ActionTypes.RESET_STATE_PLATFORM_FEE_DETAILS,
        payload,
    };
};

export const setActiveFilters = (payload) => {
    return {
        type: ActionTypes.SET_PLATFORM_FEE_DETAILS_ACTIVE_FILTERS,
        payload,
    };
};

export const getPlatformFeeDetails = (filters) => async (dispatch) => {
    if (Object.keys(filters).length > 0) {
        dispatch(setActiveFilters(filters));
    } else if (Object.keys(filters).length === 0) {
        dispatch(resetState({ state: "activeFilters" }));
    }

    try {
        dispatch(setLoader(true));
        const response = await PlatformFeeDetails.getPlatformFeeDetails({ ...filters });
        dispatch(setLoader(false));
        if (response) {
            dispatch(setPlatformFeeDetails(response));
            dispatch(
                setStatus({
                    type: "success",
                    message: SuccessMessages.RETRIEVAL_SUCCESS,
                })
            );
        }
        return response;
    } catch (err) {
        dispatch(setLoader(false));
        dispatch(
            setStatus({
                type: "error",
                message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
            })
        );
        handleError(err);
    }
};
